export const GET_BUILDING_REQUEST = '[BUILDING] GET_BUILDING_REQUEST';
export const GET_BUILDING_SUCCESS = '[BUILDING] GET_BUILDING_SUCCESS';
export const GET_BUILDING_FAILED = '[BUILDING] GET_BUILDING_FAILED';

export const GET_BUILDING_LIST_REQUEST = '[BUILDING] GET_BUILDING_LIST_REQUEST'
export const GET_BUILDING_LIST_SUCCESS = '[BUILDING] GET_BUILDING_LIST_SUCCESS'
export const GET_BUILDING_LIST_FAILED = '[BUILDING] GET_BUILDING_LIST_FAILED'

export const CREATE_BUILDING_REQUEST = '[BUILDING] CREATE_BUILDING_REQUEST';
export const CREATE_BUILDING_SUCCESS = '[BUILDING] CREATE_BUILDING_SUCCESS';
export const CREATE_BUILDING_FAILED = '[BUILDING] CREATE_BUILDING_FAILED';

export const EDIT_BUILDING_REQUEST = '[BUILDING] EDIT_BUILDING_REQUEST';
export const EDIT_BUILDING_SUCCESS = '[BUILDING] EDIT_BUILDING_SUCCESS';
export const EDIT_BUILDING_FAILED = '[BUILDING] EDIT_BUILDING_FAILED';

export const DELETE_BUILDING_REQUEST = '[BUILDING] DELETE_BUILDING_REQUEST';
export const DELETE_BUILDING_SUCCESS = '[BUILDING] DELETE_BUILDING_SUCCESS';
export const DELETE_BUILDING_FAILED = '[BUILDING] DELETE_BUILDING_FAILED';

export const RESET_BUILDINGS_FORM = '[BUILDING] RESET_BUILDINGS_FORM';

export const BUILDING_SEARCH_REQUEST = '[BUILDING] BUILDING_SEARCH_REQUEST';
export const BUILDING_SEARCH_SUCCESS = '[BUILDING] BUILDING_SEARCH_SUCCESS';
export const BUILDING_SEARCH_FAILED = '[BUILDING] BUILDING_SEARCH_FAILED';